import React from 'react';
import cn from 'classnames';
import { Image } from '@landing/ui';
import { useStateModal } from 'utils/hooks';
import { GalleryModal } from 'components/Modals';

import * as styles from './GalleryImage.module.scss';

export default function GalleryImage({ item, index, items }) {
  const { image, videoSrc } = item;
  const { modalState, showModal, hideModal } = useStateModal();

  return (
    <>
      <div className={cn(styles.item, videoSrc && styles.video)} onClick={showModal}>
        <Image className={styles.picture} classImage={styles.image} src={image} />
      </div>
      {modalState.isOpen && (
        <GalleryModal
          isOpen={modalState.isOpen}
          closeModalCallback={hideModal}
          items={items}
          index={index}
        />
      )}
    </>
  );
}
